import ModuleRoute from "components/ModuleRoute/ModuleRoute";
import PageRoute from "components/PageRoute/PageRoute";
import React from "react";
import { RouteObject } from "react-router-dom";

const UserLevelModule = React.lazy(() => import("./UserLevelModule"));
const HomePage = React.lazy(() => import("./pages/HomePage/HomePage"));
const CreatePage = React.lazy(() => import("./pages/CreatePage/CreatePage"));

export const UserLevelModuleRoutes: RouteObject = {
  path: ":clientId",
  element: <ModuleRoute El={UserLevelModule} moduleName="user-home" />,
  children: [
    {
      path: "user-home",
      element: <PageRoute El={HomePage} />,
    },
    {
      path: "create-project",
      element: <PageRoute El={CreatePage} />,
    },
  ],
};
